// window.React_App_BASE_URL is injected at container start by nginx/entrypoint.sh
// (loaded via public/index.html before the bundle). process.env fallback keeps
// local `npm start` working from a build-time .env.
export const baseUrl = window.React_App_BASE_URL || process.env.React_App_BASE_URL;
export const accessToken  = localStorage.getItem('accessToken');